import React, { FC } from 'react';
import styled from 'styled-components';

const FirstChrarter = styled.span<{ color: string }>`
  font-size: 1.5rem;
  font-weight: bold;
  color: ${(props) => props.color};
`;
const RestOfCharacters = styled.span<{ color: string }>`
  font-size: 1rem;
  font-weight: bold;
  color: ${(props) => props.color || 'lightgray'};
`;
const ThirdCharacter = styled.span<{ color: string }>`
  font-size: 1.25rem;
  font-weight: bold;
  color: ${(props) => props.color || 'lightgray'};
`;
const getMarginResult = (margin: string): Array<string> => {
  if (margin.includes('&')) {
    return margin.replaceAll(' ', '').split('');
  }
  return [margin.substring(0, 1), margin.replaceAll(' ', '').substring(1)];
};

const ResultMargin = styled.div<{ bgColor?: string | null }>`
  margin: 0 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
`;

export const Arrow = styled.i`
  display: inline-block;
  width: 10px;
  height: 10px;
  vertical-align: middle;
  margin: 0 0.25rem;
`;

export const ArrowUp = styled(Arrow)<{ color: string }>`
  border: ${(props) => `solid ${props.color}`};
  border-width: 0 4px 4px 0;
  padding: 4px;
  transform: rotate(-135deg);
  margin-top: 0.5rem;
`;

export const ArrowDown = styled(Arrow)<{ color: string }>`
  border: ${(props) => `solid ${props.color}`};
  border-width: 0 4px 4px 0;
  padding: 4px;
  transform: rotate(45deg);
  margin-top: 0.25rem;
`;

type Props = {
  margin: string;
  color: string;
};

export const ResultMarginDisplay: FC<Props> = ({ margin, color }): JSX.Element => {
  const parts = getMarginResult(margin);

  return (
    <ResultMargin>
      {!margin || margin === 'A/S' ? (
        <ThirdCharacter color={'grey'}>A/S</ThirdCharacter>
      ) : (
        <div>
          <FirstChrarter color={color}>{parts[0]}</FirstChrarter>
          <RestOfCharacters color={color}>{parts[1]}</RestOfCharacters>
          {parts.length > 2 && <ThirdCharacter color={color}>{parts[2]}</ThirdCharacter>}
        </div>
      )}
    </ResultMargin>
  );
};
